(() => {
  if (!customElements.get("read-more-text")) {
    class ReadMoreText extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => this.init());
      }

      init() {
        const description = this.querySelector("[data-description]");
        const button = this.querySelector("[data-read-more-button]");

        if (!description || !button) return;

        const charLimit = parseInt(this.dataset.charLimit) || 150;
        const textContent = description.textContent.trim();

        if (textContent.length <= charLimit) {
          button.hidden = true;
          return;
        }

        const originalHTML = description.innerHTML;
        let isExpanded = false;

        this.truncate(description, charLimit);

        button.addEventListener(
          "click",
          () => {
            isExpanded = !isExpanded;

            if (isExpanded) {
              description.innerHTML = originalHTML;
              button.textContent = this.dataset.readLess || "Read less";
            } else {
              this.truncate(description, charLimit);
              button.textContent = this.dataset.readMore || "Read more";
            }
          },
          { passive: true }
        );
      }

      truncate(element, limit) {
        const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
        let charCount = 0;
        let lastNode = null;
        while (walker.nextNode()) {
          const node = walker.currentNode;
          const text = node.textContent;
          const newCount = charCount + text.length;

          if (newCount > limit) {
            const remaining = limit - charCount;
            node.textContent = text.slice(0, remaining).trimEnd() + "...";
            lastNode = node;
            break;
          }

          charCount = newCount;
          lastNode = node;
        }

        if (lastNode) {
          let nextNode = walker.nextNode();
          while (nextNode) {
            const toRemove = nextNode;
            nextNode = walker.nextNode();
            toRemove.parentNode?.removeChild(toRemove);
          }
          let parent = lastNode.parentElement;
          while (parent && parent !== element) {
            const nextSibling = parent.nextSibling;
            if (nextSibling) {
              nextSibling.remove();
              while (parent.nextSibling) {
                parent.nextSibling.remove();
              }
            }
            parent = parent.parentElement;
          }
        }
      }
    }

    customElements.define("read-more-text", ReadMoreText);
  }
})();
